import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const getSuppliers = () =>
  axios
    .get(`${API_URL}/api/suppliers`, authHeaders())
    .then((r) => r.data);

const getSupplier = (id) =>
  axios
    .get(`${API_URL}/api/suppliers/${id}`, authHeaders())
    .then((r) => r.data);

const createSupplier = (data) =>
  axios
    .post(`${API_URL}/api/suppliers`, data, authHeaders())
    .then((r) => r.data);

const updateSupplier = (id, data) =>
  axios
    .put(`${API_URL}/api/suppliers/${id}`, data, authHeaders())
    .then((r) => r.data);

const deleteSupplier = (id) =>
  axios
    .delete(`${API_URL}/api/suppliers/${id}`, authHeaders())
    .then((r) => r.data);

const addRequirement = (supplierId, documentCategoryId) =>
  axios
    .post(`${API_URL}/api/suppliers/${supplierId}/requirements`, { documentCategoryId }, authHeaders())
    .then((r) => r.data);

const removeRequirement = (supplierId, requirementId) =>
  axios
    .delete(`${API_URL}/api/suppliers/${supplierId}/requirements/${requirementId}`, authHeaders())
    .then((r) => r.data);

const getComplianceOverview = () =>
  axios
    .get(`${API_URL}/api/suppliers/compliance-overview`, authHeaders())
    .then((r) => r.data);

const getFsvpChecklist = (supplierId) =>
  axios
    .get(`${API_URL}/api/suppliers/${supplierId}/fsvp-checklist`, authHeaders())
    .then((r) => r.data);

const saveFsvpChecklistItem = (supplierId, templateId, data) =>
  axios
    .put(`${API_URL}/api/suppliers/${supplierId}/fsvp-checklist/${templateId}`, data, authHeaders())
    .then((r) => r.data);

const exportCsv = async () => {
  const res = await axios.get(`${API_URL}/api/suppliers/export`, { ...authHeaders(), responseType: 'blob' });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = href; a.download = 'suppliers.csv'; a.click();
  URL.revokeObjectURL(href);
};

const supplierService = {
  getSuppliers,
  getSupplier,
  createSupplier,
  updateSupplier,
  deleteSupplier,
  addRequirement,
  removeRequirement,
  getComplianceOverview,
  getFsvpChecklist,
  saveFsvpChecklistItem,
  exportCsv,
};

export default supplierService;
